import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { Modal } from "@/shared/ui/modal"
import notify from "@/shared/lib/notify"
import { closeDeleteInvitationModal, fetchDeleteInvitation, selectDeleteInvitationModalOpen, selectOnDelete } from "../../model"
import { getErrorMessage } from "@/shared/consts/error-codes"
import { useForm } from "react-hook-form"

export const DeleteInvitationModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectDeleteInvitationModalOpen)
    const onDelete = useAppSelector(selectOnDelete)

    const handleClose = () => {
        dispatch(closeDeleteInvitationModal())
    }

    const onSubmit = async () => {
        await new Promise((res, rej) => {
            dispatch(fetchDeleteInvitation())
                .unwrap()
                .then(() => {
                    notify.success('Приглашение успешно удалено')
                    reset()
                    onDelete?.()
                    handleClose()
                    res('')
                }).catch((e) => {
                    notify.error(getErrorMessage(e))
                    rej()
                })
        })
    }

    const {
        handleSubmit,
        reset,
        formState: {
            isSubmitting
        }
    } = useForm()

    return (
        <Modal
            isOpen={isOpen}
            title="Удаление приглашения"
            onRequestClose={handleClose}
        >
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
                <div>
                    Вы уверены, что хотите удалить выбранное приглашение?
                </div>
                <div className="w-full flex gap-3">
                    <button onClick={handleClose} className="form_cancel_button">
                        Отменить
                    </button>
                    <button disabled={isSubmitting} className="form_handle_button" type="submit">
                        Удалить
                    </button>
                </div>
            </form>
        </Modal>
    )
}